import '@wix/sled-test-runner';

type UnpackPromise<T> = T extends Promise<infer U> ? U : T;

export type SledPage = UnpackPromise<ReturnType<typeof sled['newPage']>>;
